import { IPoint } from './GeographyTypes'

/**
 * Convert a point representing a geographical coordinate in GeoJSON format into a string representing (latitude, longitude).
 * This format is easier for a human to read and copy/paste into other applications for troubleshooting purposes.
 */
export const toLatLongString = (point: IPoint): string => {
  // Be extra defensive here to avoid throwing run-time errors, since this function may be called during error handling
  const maybePoint: Partial<IPoint> = point
  const latitude =
    maybePoint?.coordinates && maybePoint.coordinates.length > 1 ? maybePoint.coordinates[1] : '[missing latitude]'
  const longitude =
    maybePoint?.coordinates && maybePoint.coordinates.length > 0 ? maybePoint.coordinates[0] : '[missing longitude]'
  return `(${latitude},${longitude})`
}
